import { IPOSConfig, IPOSConfigStatus } from "@/types/db/pos-config";
import {
  Get_PosConfigQuery,
  Get_PosConfigQueryVariables,
  Get_PosConfigsQuery,
  Get_PosConfigsQueryVariables,
} from "@/types/gql/generated/graphql";
import { POSConfig } from "@/types/gql/PosConfigs";
import { apolloClient } from "@/utils/graphql-client";
import {
  GET_PosConfig,
  GET_PosConfigs,
} from "./queries/sales-configurations.graphql";

/**
 * Returns sales configurations related to a user.
 *
 * @param groupId a list of ticket group ids
 */
export async function getSalesConfigurations(
  groupId: number,
  statuses: IPOSConfigStatus[]
): Promise<POSConfig[]> {
  const res = await apolloClient.query<
    Get_PosConfigsQuery,
    Get_PosConfigsQueryVariables
  >({
    query: GET_PosConfigs,
    variables: {
      groupId: `(GroupId,eq,${groupId})`,
      condition: {
        Status: {
          in: statuses.map((el) => String(el)),
        },
      },
    },
  });

  const posConfigs = res.data.salesConfigs;

  if (!posConfigs) {
    return [];
  }

  return posConfigs.filter((conf) => !!conf) as POSConfig[];
}

/**
 * Returns sales configuration already selected by the user.
 *
 */
export async function getSalesConfigurationById(
  id: number
): Promise<POSConfig[]> {
  const res = await apolloClient.query<
    Get_PosConfigQuery,
    Get_PosConfigQueryVariables
  >({
    query: GET_PosConfig,
    variables: {
      id: `(id,eq,${id})`,
    },
  });

  const posConfigs = res.data.salesConfigs;

  if (!posConfigs) {
    return [];
  }

  return posConfigs.filter((conf) => !!conf) as POSConfig[];
}
